import { createFileRoute } from '@tanstack/react-router';
import { StapleSettingsScreen } from '../features/settings/StapleSettings.tsx';

export const Route = createFileRoute('/settings_/staples')({ component: StapleSettingsScreen });
